export const GET_LMKEYWORDS_API_REQUEST = "GET_LMKEYWORDS_API_REQUEST";
export const GET_LMKEYWORDS_API_SUCCESS = "GET_LMKEYWORDS_API_SUCCESS";
export const GET_LMKEYWORDS_API_ERROR = "GET_LMKEYWORDS_API_ERROR";

export const POST_LMKEYWORDS_API_REQUEST = "POST_LMKEYWORDS_API_REQUEST";
export const POST_LMKEYWORDS_API_SUCCESS = "POST_LMKEYWORDS_API_SUCCESS";
export const POST_LMKEYWORDS_API_ERROR = "POST_LMKEYWORDS_API_ERROR";
